module.exports = __webpack_public_path__ + "img/exchange.afb84e46.png";